export function Reveal({ children, delay = 0, className = "" }) {
    return (
        <div
            className={`opacity-0 animate-fade-up ${className}`}
            style={{ animationDelay: `${delay}ms` }}
        >
            {children}
        </div>
    );
}

export function Divider({ label }) {
    return (
        <div className="divider-diamond">
            {label ? <span className="font-script text-3xl text-kayama-gold">{label}</span> : <span className="text-kayama-gold">◆</span>}
        </div>
    );
}

export function Overline({ children, className = "" }) {
    return <span className={`overline ${className}`}>{children}</span>;
}
